import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const COLUMN_COUNT = 2;
const ROW_COUNT = 10;

const AssetClassesTableSkeleton = ({ showSearch }: { showSearch?: boolean }) => (
  <HtmlTable variant="bordered" columnSpacing="small" maxHeight="60vh">
    <table style={{ tableLayout: 'fixed' }}>
      <colgroup>
        <col width="50%" />
        <col width="50%" />
      </colgroup>
      <thead style={{ position: 'sticky', zIndex: 2, top: 0 }}>
        <tr>
          <th colSpan={COLUMN_COUNT}>
            <Shimmer height={20} width={200} />
          </th>
        </tr>
        {showSearch && (
          <tr>
            <th colSpan={COLUMN_COUNT}>
              <Shimmer height={36} width="100%" />
            </th>
          </tr>
        )}
        <tr>
          <th>
            <Shimmer height={16} width={140} />
          </th>
          <th>
            <Shimmer height={16} width={120} />
          </th>
        </tr>
      </thead>
      <tbody>
        {times(ROW_COUNT).map(key => (
          <tr key={key}>
            <td>
              <Shimmer height={16} width="100%" />
            </td>
            <td>
              <Shimmer height={16} width="100%" />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </HtmlTable>
);

export const AssetClassesLoading = () => (
  <Box
    display="flex"
    minHeight={300}
    css={({ theme }) => ({
      gap: theme.space['24'],
    })}
  >
    <Box minWidth={0} flex={1}>
      <AssetClassesTableSkeleton />
    </Box>
    <Box minWidth={0} flex={1}>
      <AssetClassesTableSkeleton showSearch />
    </Box>
  </Box>
);
